import { frontendURL } from '../../../helper/URLHelper';
import WhatsappTemplate from './template/Index.vue';
import CreateTemplate from './template/CreateTemplate.vue';
import store from '../../../store/index';
import { subscriptionGuard } from '../../../helper/subscriptionHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/whatsapp_template'),
      name: 'whatsapp_template',
      component: WhatsappTemplate,
      meta: {
        permissions: ['administrator', 'restricted'],
      },
      beforeEnter: async (to, from, next) => {
        await subscriptionGuard(to, from, next, store);
      },
    },
    {
      path: frontendURL('accounts/:accountId/whatsapp_template/create'),
      name: 'whatsapp_template_create',
      component: CreateTemplate,
      meta: {
        permissions: ['administrator', 'restricted'],
      },
      beforeEnter: async (to, from, next) => {
        await subscriptionGuard(to, from, next, store);
      },
    }
  ],
};
